import { useEffect } from "react";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { signOut } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";

export function useTokenExpirationGuard() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = Hub.listen("auth", ({ payload }) => {
            if (payload.event === "tokenRefresh_failure") {
                signOut().finally(() => {
                    dispatch({ type: "CLEAN_STORE" });
                    navigate("/");
                });
            }
        });

        return () => unsubscribe();
    }, [dispatch, navigate]);
}
